<template>
<div>
  <el-button @click="open">자원 구분키 관리</el-button>
  <w-sliding-popup ref="slidingPopup" :title="title" top="50px" width="1300px" @close="close">
    <div slot="content">
      <el-row type="flex" :gutter="30">
        <el-col :span="6">
          <div class="title-h3 mr-b10 mr-t5">관리자원</div>
          <el-row type="flex">
            <el-select style="width: 130px;" class="mr-r5" v-show="managetypeId == 'FMS'||managetypeId == 'DBMS'||managetypeId == 'VMS'" v-model="managetypeKey">
              <el-option v-for="item in managetypeKeyList" :key="item.managetypeKey" :label="item.managetypeKeyName" :value="item.managetypeKey"></el-option>
            </el-select>
            <w-search-field ref="searchField" class="title-bar" :width="managetypeId == 'FMS'||managetypeId == 'DBMS'||managetypeId == 'VMS' ? 'calc(100% - 133px)' : '100%'"
              @search="filterTree" />
          </el-row>
          <el-row>
            <el-tree v-loading="loading" ref="rscTree" :data="rscTreeData" :props="defaultProps" :node-key="defaultProps.treeKey" highlight-current expand-on-click-node :filter-node-method="filterNode" @node-click="clickNode"></el-tree>
          </el-row>
        </el-col>
        <el-col :span="18">
          <el-row type="flex" class="mr-b5" justify="space-between">
            <div class="vertical-center-box">
              <div class="title-h3">{{rscName}}자원 구분 키</div>
            </div>
            <div class="vertical-center-box">
              <el-button size="mini" class="mr-r5" :disabled="!(checkedRows.length > 0)" @click="deleteObjRscKeyList">삭제</el-button>
              <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
            </div>
          </el-row>
          <el-table-wrapper v-loading="loadingRsc" ref="objRscKeyListTable" :data="objRsckeyList" :columns="columns" :column-default="columnDefault"
            pagination :show-search-tool="showSearchTool" :show-custom-header="true" @selection-change="changeCheckedRow">
          </el-table-wrapper>
        </el-col>
      </el-row>
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
import { isNil, isEmpty, isEqual } from 'lodash';
import msgUtil from '@/utils/message';
import WSearchField from '@/components/form/SearchField';
import TreeFilter from '@/mixins/tree/filter';
import { defaultProps } from '@/constants/tree';
import EventSettingsAPI from '@/api/settings/common/event-settings';
import ManagetypeKeyAPI from '@/api/model/managetype-key';
import { COMMON_KEY } from '@/constants/managetype-key';
import { columnDefault } from '@/constants/table';
import CommonApi from '@/api/performance/common';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';

export default {
  name: 'WObjRscKeySettingPopup',
  components: {
    WSearchField,
  },
  mixins: [TreeFilter],
  props: {
    objInfo: {
      type: Object,
    },
    agentObjId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      columnDefault,
      defaultProps,
      showSearchTool: false,
      loading: false,
      loadingRsc: false,
      treeRef: 'rscTree',
      rscTreeData: [],
      managetypeKeyList: [],
      managetypeIdKey: null,
      managetypeId: null,
      managetypeKey: null,
      selectedNode: null,
      objRsckeyList: [],
      checkedRows: [],
      columns: [
        {
          type: 'selection',
        },
        {
          prop: 'rsctypeName',
          label: '자원 구분명',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'rscName',
          label: '자원명',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'rscKeyName',
          label: '자원 구분 키',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'timestamp',
          label: '최근 수집 시각',
          formatter: this.getDateFormatter,
          searchType: 'date',
          searchable: true,
          sortable: true,
        },
      ],
    };
  },
  computed: {
    /**
     * 트리에서 선택한 자원 이름 설정
     * @author Song
     */
    rscName() {
      if (this.selectedNode) {
        return `[${this.selectedNode.label}] `;
      }
      return '';
    },
    title() {
      if (this.objInfo) {
        return `[${this.objInfo.obj.objName}] 자원 구분키 관리`;
      }
      return '자원 구분키 관리';
    },
  },
  watch: {
    managetypeKey: {
      immediate: true,
      handler(value) {
        const managetypeId = this.managetypeId;
        if (!isNil(value)) {
          // 수집 구분 관리키는 objId 별 상이하기 때문에 포함시킨다.
          this.managetypeIdKey = `${this.objInfo.obj.objId}.${managetypeId}.${value}`;
        }
      },
    },
    managetypeIdKey: {
      immediate: true,
      handler(value) {
        this.selectedNode = null;
        if (!isNil(value) && !isNil(this.managetypeKey)) {
          this.loadData();
        }
      },
    },
  },
  methods: {
    /**
     * 현재 obj에 해당하는 자원 수집 키를 조회한다.
     * @author Song
     */
    open() {
      this.$refs.slidingPopup.open();
      this.managetypeId = this.objInfo.obj.objManagetypeId;
      this.getManagetypeKey(this.managetypeId);
      console.log(this.objInfo);
    },
    close() {
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 해당 obj_rsc_key를 삭제한다.
     * @author Song
     */
    loadData() {
      const managetypeId = this.managetypeId;
      const managetypeKey = this.managetypeKey;
      this.loading = true;
      EventSettingsAPI.getRscTreeByManagetypeId({
        managetypeId,
        managetypeKey,
      })
        .then((response) => {
          if (response.data.success) {
            this.rscTreeData = response.data.data;
            this.$nextTick(() => {
              if (!isEmpty(this.rscTreeData)) {
                let currentKey;
                if (isNil(this.selectedNode)) {
                  this.clickNode(this.rscTreeData[0]);
                  currentKey = this.rscTreeData[0].treeKey;
                } else {
                  this.clickNode(this.selectedNode);
                  currentKey = this.selectedNode.treeKey;
                }
                this.$refs.rscTree.setCurrentKey(currentKey);
                this.$refs.searchField.clear();
              }
            });
          } else {
            this.failToLoad();
          }
        })
        .catch(() => {
          this.failToLoad();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    failToLoad() {
      this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '자원 구분키', false));
    },
    /**
     * 좌측 자원트리 클릭 이벤트
     * @author Song
     */
    clickNode(nodeData) {
      this.selectedNode = nodeData;
      this.loadingRsc = true;
      // 자원 구분 키관리 api 호출
      const params = {
        objId: this.objInfo.obj.objManagetypeId === 'E2E' ? this.agentObjId : this.objInfo.obj.objId,
        rsctypeId: this.selectedNode.rsctypeId,
        rscId: this.selectedNode.rscId,
      };
      CommonApi.getObjRscKeyList(params).then((res) => {
        if (res.data.success) {
          this.objRsckeyList = res.data.data;
        }
      }).finally(() => {
        this.loadingRsc = false;
      });
    },
    /**
     * 해당하는 managetypeKey를 조회한다.
     * @author Song
     */
    getManagetypeKey(value) {
      if (isEqual(value, 'FMS') || isEqual(value, 'DBMS') || isEqual(value, 'VMS')) {
        ManagetypeKeyAPI.getDisplayedManagetypeKeyList(value)
          .then((response) => {
            if (response.data.success === true) {
              this.managetypeKeyList = response.data.data;
              this.managetypeKey = this.managetypeKeyList[0].managetypeKey;
            } else {
              this.managetypeKeyList = null;
            }
          })
          .catch(() => {
            this.managetypeKeyList = null;
          });
      } else if (isEqual(value, 'NMS')) {
        this.managetypeKey = this.objInfo.obj.objtypeId !== 'NETINTERFACE' ? 'ND' : 'NI';
      } else {
        this.managetypeKey = COMMON_KEY;
      }
      this.managetypeIdKey = `${this.objInfo.obj.objId}.${value}.${this.managetypeKey}`;
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    changeCheckedRow(selection) {
      this.checkedRows = selection;
    },
    /**
     * 해당 obj_rsc_key를 삭제한다.
     * @author Song
     */
    deleteObjRscKeyList() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE))
        .then(() => {
          CommonApi.deleteObjRscKeyList(this.checkedRows).then((res) => {
            if (res.data.success) {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '자원 구분키', true));
              this.loadData();
            } else {
              this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '자원 구분키', false));
            }
          });
        }).catch(() => {});
    },
    /**
     * 수집시간 timestamp 날짜포맷
     * @author Song
     */
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ObjRscKeyManagePopup.vue